import { SaveStatus } from "@/hooks/useAutoSave";

interface AutoSaveIndicatorProps {
  status: SaveStatus;
  lastSaved: Date | null;
}

export const AutoSaveIndicator = ({ status, lastSaved }: AutoSaveIndicatorProps) => {
  if (status === "idle" && !lastSaved) return null;

  return (
    <div className="flex items-center gap-2 text-xs text-muted-foreground">
      {status === "saving" && (
        <>
          <span className="w-2 h-2 rounded-full bg-yellow-500 animate-pulse" />
          Saving...
        </>
      )}
      {status === "saved" && (
        <>
          <span className="w-2 h-2 rounded-full bg-green-500" />
          Saved {lastSaved && `at ${lastSaved.toLocaleTimeString()}`}
        </>
      )}
      {status === "error" && (
        <>
          <span className="w-2 h-2 rounded-full bg-destructive" />
          Save failed
        </>
      )}
    </div>
  );
};
